import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { CookiesKeys, URLs } from "../../Constants/Consts";
import { getCompletePath2 } from "../../Helpers/Functions";
import { updateCheckListItem } from "../../store/SequenceObject";
import { RootState } from "../../store/store";
import { DDCheckList } from "../../types/DataDD/DataDD";
import { ObjectToSync, UUID } from "../../types/types";
import { SyncItemsTypes } from "./SyncItemsTypes";

export default function (): { getChecklistItemsToSync: () => ObjectToSync[], updateSyncItem: (itemId: UUID) => void, cancelSyncItem: (itemId: UUID) => void } {
    const { ChecklistsObject } = useSelector((state: RootState) => state.SequenceObject)
    const { account } = useSelector((state: RootState) => state.SelectedUser)
    const dispatch = useDispatch()
    // traverse into the object to get all the notSync items 
    const getChecklistItemsToSync = () => {
        const checkList = findSyncSequences(ChecklistsObject)
        const jwt = Cookies.get(CookiesKeys.jwt)
        return checkList.map(d => {
            const method = d.creation ? "POST" : "PATCH"
            const url = d.creation ? URLs.postDDADHOC() : URLs.updateDD(d.ctUuid)
            const payload = d.creation ? d : { statusId: d.statusId }
            const localBaseTimestamp = ((d as any)?.dateModified ? String((d as any).dateModified) : d?.inspectionVersion ? String(d.inspectionVersion) : null)
            return {
                url,
                payload,
                method,
                type: SyncItemsTypes.CheckListItem,
                jwt,
                account,
                syncMeta: {
                    queueId: `checklist:${d.ctUuid}`,
                    itemId: d.ctUuid,
                    itemLabel: d.taskDescription || d.taskHeader || d.ctUuid,
                    resourceType: SyncItemsTypes.CheckListItem,
                    localBaseTimestamp,
                    localUpdatedAt: new Date().toISOString(),
                }
            }
        })
    }
    const updateSyncItem = (itemId) => {
        const checkList = findSyncSequences(ChecklistsObject)       
        const checklistItem = checkList.find(c => c.ctUuid.toLocaleLowerCase() === itemId.toLocaleLowerCase())
        if (checklistItem) {
            // console.log("complete", getCompletePath2(checklistItem));            
            dispatch(updateCheckListItem({
                completePath: getCompletePath2(checklistItem),
                checklistItem: { ...checklistItem, notSync: false, creation: false }
            }))
        }
    }

    const cancelSyncItem = (itemId) => {
        const checkList = findSyncSequences(ChecklistsObject)
        const checklistItem = checkList.find(c => c.ctUuid.toLocaleLowerCase() === itemId.toLocaleLowerCase())
        if (checklistItem) {
            const revertedStatus = checklistItem.previousStatusId ?? checklistItem.statusId
            dispatch(updateCheckListItem({
                completePath: getCompletePath2(checklistItem),
                checklistItem: {
                    ...checklistItem,
                    statusId: revertedStatus,
                    notSync: false,
                    creation: false,
                    previousStatusId: undefined,
                }
            }))
        }
    }

    return { getChecklistItemsToSync, updateSyncItem, cancelSyncItem }
}

export function findSyncSequences(obj) {
    let result = new Array<DDCheckList>;
    for (let prop in obj) {
        if (typeof obj[prop] === 'object' && obj[prop] !== null) {
            result = result.concat(findSyncSequences(obj[prop]));
        } else if (prop === 'notSync' && (obj[prop] === true)) {
            result.push(obj);
        }
    }
    return result;
}